











































































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { Cycle } from '@/api/cycles';
import { RecompCycleProductSummary } from '@/api/recomp';
import { Product } from '@/api/product';
import moment from 'moment';

@Component({
  computed: mapState(['fiId']),
})
export default class RecompTotalSummaryCard extends Vue {
  @Prop() reloadId!: string;

  @Prop() recompCycles!: Cycle[];

  @Prop() allRecompCycleProductSummaries!:RecompCycleProductSummary[];

  fiId!: number;

  loading: boolean = true;

  headers: DataTableHeader[] = [
    { text: 'Product', value: 'productName' },
    { text: 'Accounts', value: 'accountCount' },
    { text: 'ATM Rewards', value: 'atmRewards' },
    { text: 'Interest Adjustment', value: 'interestAdjustment' },
    { text: 'Cash Back Amount', value: 'cashBackAmount' },
    { text: 'Net Service Fee Amount', value: 'netServiceFeeAmount' },
    { text: 'Tunes Credit Paid', value: 'tunesCreditAmount' },
    { text: 'Eats Rewards', value: 'eatsReward' },
    { text: 'Streaming Rewards', value: 'streamingReward' },
    { text: 'Total Rewards Distributed', value: 'totalRewardsAmount' },
  ];

  displayedRecompSummaries:RecompCycleProductSummary[] = [];

  selectedSummaryCycleIndex:number = 0;

  mounted() {
    this.initializeView();
  }

  @Watch('allRecompCycleProductSummaries')
  async initializeView() {
	  if (this.allRecompCycleProductSummaries.length > 0) {
	    this.updateOverallSummaryView(0, null);
    }
  }

  updateOverallSummaryView(selectedIndex:number, selectedCycleId:any) {
    this.loading = true;
    this.selectedSummaryCycleIndex = selectedIndex;
    this.displayedRecompSummaries = this.allRecompCycleProductSummaries.filter((recompSummary:RecompCycleProductSummary) => recompSummary.cycleId === selectedCycleId);
    this.loading = false;
  }

  getCycleHeaderAllCyclesFriendlyDate(): string {
    const formattedStartDate = (moment(this.recompCycles[0].qualificationStartDate)).format('MM/DD');
    const formattedEndDate = (moment(this.recompCycles[this.recompCycles.length - 1].qualificationEndDate)).format('MM/DD');

    return `ALL CYCLES (${formattedStartDate}-${formattedEndDate})`;
  }

  getCycleHeaderFriendlyDate(cycle: Cycle): string {
    const reloadId = this.reloadId;
    const formattedStartDate = (moment(cycle.qualificationStartDate)).format('MM/DD');
    const formattedEndDate = (moment(cycle.qualificationEndDate)).format('MM/DD');

    return `${formattedStartDate}-${formattedEndDate}`;
  }

  /* eslint-disable class-methods-use-this */
  getFormattedMoney(amount:string):string {
    if (amount.startsWith('-')) {
      return `$(${amount.substring(1)})`;
    }
    return `$${amount}`;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
